import {
    Leave,
    Dashboard,
    PlanLeave,
    PlanLeaveDetails,
    AvailedLeave,
    AvailedLeaveUserDetails,
    AvailedSummaryLeave,
    LastLeaveAvailed,
    LastLeaveAvailedOfficer,
    LeaveChart,
    LeaveStatus,
    AvailedLeaveMonthly,
    LeaveCompanyStatus,
    LeaveDeviationDetails,
    LeavePresentDetails,
    LeaveAbsentDetails,
} from "../Components";

export default [
    {
        path: "/report/leave/dashboard",
        component: Dashboard,
        name: "report-leave-dashboard",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/my-leave",
        component: Leave,
        name: "report.my.leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/plan-leave",
        component: PlanLeave,
        name: "report.plan.leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/plan-leave-details",
        component: PlanLeaveDetails,
        name: "report.plan.leave.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/availed-leave",
        component: AvailedLeave,
        name: "report.availed.leave",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/availed-leave-user-details/:user_id",
        component: AvailedLeaveUserDetails,
        name: "report.availed.leave.user.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/availed-leave-user-details",
        component: AvailedLeaveUserDetails,
        name: "report.my.availed.leave.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/availed-summary-leave",
        component: AvailedSummaryLeave,
        name: "report.availed.leave.summary",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/availed-monthly-summary-leave",
        component: AvailedLeaveMonthly,
        name: "report.availed.leave.monthly.summary",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: "/report/availed-leave-monthly", component: AvailedLeaveMonthly, name: "report.availed.leave.monthly" ,

    {
        path: "/report/last-availed-leave",
        component: LastLeaveAvailed,
        name: "report.last.leave.availed",
        meta: {
            requiresAuth: true,
        },
    },
    // { path: "/report/last-availed-leave-officer", component: LastLeaveAvailedOfficer, name: "report.last.leave.availed.officer" ,

    {
        path: "/report/monthly-chart",
        component: LeaveChart,
        name: "report.monthly.chart",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/leave-status",
        component: LeaveStatus,
        name: "report.leave.status",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/leave-status-present-details/:date",
        component: LeavePresentDetails,
        name: "report.leave.present.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/leave-status-absent-details/:date",
        component: LeaveAbsentDetails,
        name: "report.leave.absent.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/company-leave-status",
        component: LeaveCompanyStatus,
        name: "report.company.leave.status",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/leave-type-status/:date",
        component: LeaveDeviationDetails,
        name: "report.leave.type.status",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company-leave/summary",
        component: () => import("@/App/Leave/Reports/Components/CompanyLeaveSummary.vue"),
        name: "report-company-leave-summary",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/company-leave-type/summary",
        component: () => import("@/App/Leave/Reports/Components/CompanyLeaveTypeSummary.vue"),
        name: "report-company-leave-type-summary",
        meta: {
            requiresAuth: true,
        },
    },
];
